import React, { createContext, useState, useEffect, useContext } from 'react';
import i18n from 'i18next';

// Context türü tanımlama
interface LanguageContextType {
  language: string;
  setLanguage: (lang: string) => void;
  forceUpdate: () => void;
}

// Context oluşturma
const LanguageContext = createContext<LanguageContextType>({
  language: i18n.language || 'en',
  setLanguage: () => {},
  forceUpdate: () => {},
});

// Hook tanımlama
export const useLanguageContext = () => useContext(LanguageContext);

// Provider bileşeni
export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [language, setLanguageState] = useState(i18n.language || 'en');
  const [updateCounter, setUpdateCounter] = useState(0);
  
  // Language değiştiğinde bileşenleri yeniden render etmeyi tetikler
  const forceUpdate = () => {
    setUpdateCounter(prev => prev + 1);
  };

  // Dil değiştirme fonksiyonu
  const setLanguage = (lang: string) => {
    if (lang !== language) {
      i18n.changeLanguage(lang).then(() => {
        setLanguageState(lang);
        forceUpdate();
      });
    }
  };

  // Dil değişikliklerini dinleme
  useEffect(() => {
    const handleLanguageChanged = (lng: string) => {
      setLanguageState(lng);
      forceUpdate();
    };

    i18n.on('languageChanged', handleLanguageChanged);
    
    return () => {
      i18n.off('languageChanged', handleLanguageChanged);
    };
  }, []);

  return (
    <LanguageContext.Provider value={{ language, setLanguage, forceUpdate }}>
      {children}
    </LanguageContext.Provider>
  );
};